import { Button } from "@mui/material";
import React, { useRef } from "react";
import CONSTANTS from "../../../CONSTANTS";
import gema_logo from "../../../assets/img/vacspl/gema_logo.png";
// import emailModals from "../emailModals";
import EmailFooter from "../EmailFooter";
import EmailSignature from "../EmailSignature";



const Format = (props) => {
    const contentRef = useRef();
    const { 
        // form, 
        selectedSpare = {}, user, spareConf = {} } = props.data
    const { data: { form: { client = {} } } } = props


    const copyToClipboard = () => {


        if (contentRef.current) {
            const contentHtml = contentRef.current.innerHTML;

            // Create a temporary element to copy the HTML as rich text
            const tempElement = document.createElement("div");
            tempElement.style.position = "absolute";
            tempElement.style.left = "-9999px";
            tempElement.innerHTML = contentHtml;

            document.body.appendChild(tempElement);

            const range = document.createRange();
            range.selectNodeContents(tempElement);

            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            try {
                document.execCommand("copy");
                alert("Content copied successfully!");
            } catch (err) {
                console.error("Failed to copy content:", err);
                alert("Failed to copy content.");
            }

            document.body.removeChild(tempElement);
        }
        // return
        // emailModals.createServiceAPI(form, selectedSpare)
    };

    const email2 = () => {

        return (
            <div style={{ fontFamily: "'Roboto', sans-serif", backgroundColor: "#f4f4f4", padding: "20px", textAlign: "center" }}>
                <div
                    style={{
                        maxWidth: "600px",
                        margin: "auto",
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                        overflow: "hidden",
                    }}
                >
                    {/* Header with Logo */}
                    <div style={{ backgroundColor: "#222", padding: "20px", textAlign: "center" }}>
                        <h3 style={{ color: "#e4e4e4" }}>Value Added Coating Solution Pvt Ltd</h3>
                    </div>
                    <div className="head-gema-email" style={{ margin: "10px", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={gema_logo} alt="Parent Company Logo" />
                    </div>

                    {/* Body Content */}
                    <div style={{ padding: "20px", color: "#333", textAlign: "left", fontSize: "14px" }}>
                        <h2 style={{ color: "#0f0f0f", textAlign: "center", fontSize: "20px", fontWeight: "500" }}>🎉 Welcome to a New Level of Coating!</h2>
                        <p style={{ marginBottom: "10px" }}>Dear <strong>{client.label || "Sir"}</strong>,</p>
                        <p>We have installed your new <strong>Gema Powder Coating gun</strong>, ensuring top-tier efficiency and quality.</p>

                        <h3 style={{ color: "#0f0f0f", marginTop: "20px", marginBottom: "10px", fontSize: "16px" }}>🔧 Essential Spare Parts</h3>
                        <p >To keep your operations running smoothly, we recommend stocking up on these parts:</p>
                        {!!(selectedSpare[spareConf.key = {}] || []).length && <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px", fontSize: "13px" }}>
                            <tr style={{ backgroundColor: "#0f0f0f", color: "#fff", textAlign: "left" }}>
                                <th style={{ padding: "8px" }}>Parts Required in inventory</th>
                            </tr>
                            {selectedSpare[spareConf.key].map(item => <tr style={{ border: "1px solid #c1c1c1" }}><td style={{ padding: "4px", margin: "4px" }}>{item.label} - {item.quantity} {CONSTANTS.SPARE_UNIT_MAPPING[item.unit]}</td></tr>)}
                        </table>}

                        <h3 style={{ color: "#0f0f0f", marginTop: "20px", fontSize: "16px" }}>🛠️ Maintenance Best Practices</h3>
                        <ul style={{ paddingLeft: "20px" }}>
                            <li><strong>Daily:</strong> Clean the gun and nozzle to prevent clogging.</li>
                            <li><strong>Weekly:</strong> Inspect for wear and replace worn parts.</li>
                            <li><strong>Monthly:</strong> Conduct a full-system check for optimal performance.</li>
                        </ul>

                        <br />
                        <h3>Gun Maintenance and Cleaning Procedure:<br /></h3>
                        <p style={{ color: "#0f0f0f" }}><a href="https://drive.google.com/file/d/150I27vYhzTG1Zal36NM37AopBBwvYEGS/view" rel="noreferrer" target="_blank">Maintenance Procedure <span style={{ color: "blue" }}>(click here)</span></a></p>
                        <br />

                        <p class="highlight-black" style={{ marginTop: "10px" }}>
                            NOTE: Please note that due to the presence of local or non-original materials identified during any inspection, we will not be able to provide further service, and any existing warranty will be terminated.
                        </p>
                        <p class="highlight-black" style={{ marginTop: "10px" }}>
                            NOTE: Please be advised that the absence of a <strong>Constant Voltage Transformer (CVT)</strong> and an <strong>Air Dryer</strong> can significantly compromise the life and performance of the GEMA machine. It is mandatory to install/attach Constant Voltage Transformer (CVT) and Air Dryer with GEMA machine.
                        </p>

                        <p style={{ marginTop: "10px" }}>Refer to our detailed guide for more maintenance insights or contact our support team.</p>

                        <EmailSignature user={user} />
                    </div>

                    {/* Footer */}
                    <EmailFooter />
                </div>
            </div>
        );
    }


    return (
        <div >
            <div className="email-to-copy">
                <Button variant="contained" onClick={copyToClipboard}>Copy Email</Button>
            </div>
            <div ref={contentRef}>
                <div className="body-email">
                    <div class="container">
                        {/* <!-- Header --> */}

                        {/* <!-- Content --> */}
                        {email2()}
                    </div>
                </div>

            </div>


        </div>
    );
};

export default Format;
